// client/src/store/store_settings/utils/shippingApi.js
import axiosInstance from "../../../../../api/axiosInstance";

// Simple in-memory cache keyed by businessId
const cache = new Map();

/**
 * Fetch shipping profiles once per businessId.
 * Returns an array of zones (shippingGroups).
 */
export async function getShippingProfiles(businessId) {
  if (!businessId) return [];
  if (cache.has(businessId)) return cache.get(businessId);

  const p = axiosInstance
    .get(`/store_settings/shipping`, { params: { business_id: businessId } })
    .then((res) => ({
      shippingGroups: res.data?.shippingGroups || [],
      baseCurrency: res.data?.baseCurrency || "USD"
    }));
  // store the *promise* so concurrent callers share the same request
  cache.set(businessId, p);
  return p;
}
export async function getShippingAssignments(businessId) {
  const { data } = await axiosInstance.get(`/store_settings/shipping/assignments`, {
    params: { business_id: businessId },
  });
  // expected shape:
  // { assignments: { [profileName]: string[] productIds }, flags: { [productId]: { delivery:boolean, delivery_requires_approval:boolean, takeaway:boolean, takeaway_requires_approval:boolean } } }
  return data || { assignments: {}, flags: {} };
}

// Call this after saving store settings to refresh on next read
export function invalidateShippingProfiles(businessId) {
  cache.delete(businessId);
}
